<template>
  <div>
    <!--
    <h5 class="info-text">
      Let's start with the basic information (with validation)
    </h5>
    -->
    <div class="md-layout">
      <div class="md-layout-item md-size-40 md-small-size-100">
        <div class="picture-container">
          <div class="picture">
            <div v-if="!image">
              <img :src="avatar" class="picture-src" title="" />
            </div>
            <div v-else>
              <img :src="image" />
            </div>
            <input type="file" @change="onFileChange" />
          </div>
          <h6 class="description">Choose Picture</h6>
        </div>
      </div>

      <div class="md-layout-item md-size-60 mt-4 md-small-size-100" style="padding: 0px !important">
        <md-field :class="[
          { 'md-valid': !errors.has('firstName') && touched.firstName },
          { 'md-form-group': true },
          { 'md-error': errors.has('firstName') }
        ]">
          <md-icon>person_outline</md-icon>

          <label>First Name</label>

          <md-input v-validate="modelValidations.firstName" v-model="firstName" data-vv-name="firstName" type="text"
            name="firstName" required />

          <slide-y-down-transition>
            <md-icon v-show="errors.has('firstName')" class="error">close</md-icon>
          </slide-y-down-transition>

          <slide-y-down-transition>
            <md-icon v-show="!errors.has('firstName') && touched.firstName" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>

        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-65">
            <md-field :class="[
              { 'md-valid': !errors.has('lastName') && touched.lastName },
              { 'md-form-group': true },
              { 'md-error': errors.has('lastName') }
            ]">
              <md-icon>record_voice_over</md-icon>

              <label>Last Name</label>
              <md-input v-validate="modelValidations.lastName" v-model="lastName" data-vv-name="lastName" type="text"
                name="lastName" required />

              <slide-y-down-transition>
                <md-icon v-show="errors.has('lastName')" class="error">close</md-icon>
              </slide-y-down-transition>

              <slide-y-down-transition>
                <md-icon v-show="!errors.has('lastName') && touched.lastName" class="success">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </div>
          <div v-show="isAdminPanel" class="md-layout-item" style="padding: 0px">
            <!--<md-icon>sms</md-icon>-->

            <md-switch v-model="isReader"><span class="lbl1">Is Reader?</span></md-switch>
          </div>
        </div>

        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-65">
            <md-field :class="[
              { 'md-valid': !errors.has('cellPhone') && touched.cellPhone },
              { 'md-form-group': true },
              { 'md-error': errors.has('cellPhone') }
            ]">
              <md-icon>smartphone</md-icon>

              <label>Cell Phone</label>
              <md-input v-mask="'(999) 999 - 9999'" v-validate="modelValidations.cellPhone" v-model="cellPhone"
                data-vv-name="cellPhone" type="tel" name="cellPhone" required />

              <slide-y-down-transition>
                <md-icon v-show="errors.has('cellPhone')" class="error">close</md-icon>
              </slide-y-down-transition>

              <slide-y-down-transition>
                <md-icon v-show="!errors.has('cellPhone') && touched.cellPhone" class="success">done</md-icon>
              </slide-y-down-transition>
            </md-field>
            <!--<md-icon>sms</md-icon>-->
          </div>

          <div style="padding: 0px">
            <!--<md-icon>sms</md-icon>-->

            <div style="display: flex; align-items: center; gap: 8px;">
              <md-switch v-model="allowSMS" class="sms-switch">
              </md-switch>
              <span style="font-size: .7rem;">Allow SMS</span>
              <span class="tooltip-container" @mouseenter="showTooltip" @mouseleave="hideTooltipWithDelay">
                <i class="material-icons info-icon">info</i>
                <div class="tooltip-content" v-if="tooltipVisible" ref="tooltip">
                  <ul>
                    <li>Messaging frequency may vary.</li>
                    <li>Message and data rates may apply.</li>
                    <li>You can opt out any time by texting STOP.</li>
                    <li>
                      For assistance, text HELP or visit our website at
                      <a href="https://www.globechek.com" target="_blank"><b>globechek.com</b></a>.
                    </li>
                    <li>
                      Visit <a href="https://globechek.com/tos.html#privacy" target="_blank"><b>Privacy Policy</b></a>
                      and
                      <a href="https://globechek.com/tos.html#tos" target="_blank"><b>Terms of Service</b></a>.
                    </li>
                  </ul>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- MAILING ADDRESS -->
      <div class="md-layout-item md-size-100">
        <md-field :class="[
          { 'md-valid': !errors.has('address') && touched.address1 },
          { 'md-form-group': true },
          { 'md-error': errors.has('address') }
        ]">
          <md-icon>location_on</md-icon>
          <label>Address</label>
          <md-input v-validate="'required'" v-model="address" data-vv-name="address" type="text" name="address" />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('address')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('address') && touched.address1" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field :class="[
          { 'md-valid': !errors.has('city') && touched.city },
          { 'md-form-group': false },
          { 'md-error': errors.has('city') }
        ]">
          <md-icon>location_city</md-icon>
          <label>City</label>
          <md-input v-validate="'required'" v-model="city" data-vv-name="city" type="text" name="city" />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('city')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('city') && touched.state" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div :class="[
        { 'md-layout-item': true },
        { 'space-right-phone': true },
        { 'md-size-40': isPhone },
        { 'md-size-30': !isPhone }
      ]" class="md-layout-item md-size-50 md-small-size-100" @click="focus('state')">
        <md-field :class="[
          { 'md-valid': !errors.has('state') && touched.state },
          { 'md-form-group': true },
          { 'md-error': errors.has('state') }
        ]">
          <md-icon>outlined_flag</md-icon>
          <label>State</label>
          <md-select v-validate="'required'" id="state-select" ref="stateInput" v-model="state"
            style="margin-left: 20px" data-vv-name="state" type="text" name="state" md-dense
            @keydown.native="stateFind($event)">
            <md-option v-for="(state, index) in states" :key="state.LookupId" :id="state + '-state'"
              :value="state.LookupId" :md-value="state">{{ state.DisplayValue }}</md-option>
          </md-select>
          <slide-y-down-transition>
            <md-icon v-show="errors.has('state')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('state') && touched.state" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field :class="[
          { 'md-valid': !errors.has('zipCode') && touched.zipCode },
          { 'md-form-group': false },
          { 'md-error': errors.has('zipCode') }
        ]">
          <md-icon>location_on</md-icon>
          <label class="spaced-phone-label">Zip-Code</label>
          <md-input v-validate="'required'" ref="zipCodeInput" v-model="zipCode" data-vv-name="zipCode" type="text"
            name="zipCode" />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('zipCode')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('zipCode') && touched.zipCode" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div class="md-layout-item md-size-50 md-small-size-100" @click="focus('country')">
        <md-field :class="[
          { 'md-valid': !errors.has('country') && touched.country },
          { 'md-form-group': false },
          { 'md-error': errors.has('country') }
        ]">
          <md-icon>outlined_flag</md-icon>
          <label>Country</label>
          <md-select v-validate="'required'" id="country-select" ref="countryInput" v-model="country"
            data-vv-name="country" type="text" name="country" md-dense>
            <md-option v-for="(country, index) in countries" :key="index" :value="country.LookupId" :id="country">{{
              country.DisplayValue }}
            </md-option>
          </md-select>
          <slide-y-down-transition>
            <md-icon v-show="errors.has('country')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('country') && touched.country" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div class="md-layout-item md-size-100 ml-auto mt-4 md-small-size-100">
        <md-field :class="[
          { 'md-valid': !errors.has('email') && touched.email },
          { 'md-form-group': true },
          { 'md-error': errors.has('email') }
        ]" @keyup.enter="signIn()">
          <md-icon>email</md-icon>

          <label>Email</label>
          <md-input v-validate="modelValidations.email" v-model="email" data-vv-name="email" type="email" name="email"
            required />

          <slide-y-down-transition>
            <md-icon v-show="errors.has('email')" class="error">close</md-icon>
          </slide-y-down-transition>

          <slide-y-down-transition>
            <md-icon v-show="!errors.has('email') && touched.email" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>
    <md-dialog class="modal" :md-active.sync="showModalSMS">
      <md-dialog-title>SMS Terms & Conditions</md-dialog-title>

      <md-dialog-content>
        <ul>
          <li>Messaging frequency may vary.</li>
          <li>Message and data rates may apply.</li>
          <li>You can opt out any time by texting STOP.</li>
          <li>
            For assistance, text HELP or visit our website at
            <a href="https://www.globechek.com" target="_blank"><b>globechek.com</b></a>.
          </li>
          <li>
            Visit <a href="https://globechek.com/tos.html#privacy" target="_blank"><b>Privacy Policy</b></a> and
            <a href="https://globechek.com/tos.html#tos" target="_blank"><b>Terms of Service</b></a>.
          </li>
        </ul>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="closeSMSModal">CONFIRM</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions"
import { mapGetters, mapActions } from "vuex"
import $ from "jquery"

export default {
  components: {
    SlideYDownTransition
  },
  props: {
    avatar: {
      type: String,
      default: "/img/doctor-avatar3.png" //default-avatar.png"
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isAdminPanel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      radio_qualification: "",
      image: "",
      single: null,
      firstName: "",
      lastName: "",
      cellPhone: "",
      allowSMS: "",
      isReader: false,
      email: "",
      address: "",
      city: "",
      state: "",
      zipCode: "",
      country: "",
      countries: [],
      states: [],
      touched: {
        firstName: false,
        lastName: false,
        cellPhone: false,
        email: false,
        address: false,
        city: false,
        state: false,
        zipCode: false,
        country: false,
        allowSMS: false
      },
      modelValidations: {
        firstName: {
          required: true,
          min: 2
        },
        lastName: {
          required: true,
          min: 2
        },
        cellPhone: {
          required: true,
          min: 10
        },
        email: {
          required: true,
          email: true
        },
        radio_qualification: {
          required: true
        }
      },
      tooltipVisible: false,
      hideTimeout: null,
      showModalSMS: false,
    }
  },
  computed: {
    ...mapGetters(["drPersonal", "drCredentials", "isPhone"])
  },
  watch: {
    firstName() {
      this.touched.firstName = true
    },
    lastName() {
      this.touched.lastName = true
    },
    email() {
      this.touched.email = true
    },
    allowSMS(val) {
      if (val && (this.touched.allowSMS || !this.isEdit)) {
        this.showModalSMS = true
      }

      this.touched.allowSMS = true
    }
  },
  mounted() {
    this.defineLookups()
  },
  methods: {
    // TODO - change this to use store, as we call it in multiple steps
    ...mapActions(["listLookupsByMasterName"]),
    stateFind(event) {
      if (event.key === "Escape") {
        this.stateFilterKeys = ""
      }
      if (event.key === "Enter") {
        this.reRenderState()
        this.$refs.zipCodeInput.$el.focus()
      }
      if (event.key.length > 1) return
      if (this.stateFilterKeys.length < 2) {
        this.stateFilterKeys += event.key.toUpperCase()
      } else {
        this.stateFilterKeys = event.key.toUpperCase()
      }
      let foundState = this.states.find((state) => {
        return state.startsWith(this.stateFilterKeys)
      })
      if (!foundState) {
        this.stateFilterKeys = ""
        return
      }
      this.state = foundState
      let value = this.states.indexOf(foundState) * 43
      let stateID = $("#" + foundState + "-state")
      let scrollParent = $(stateID).parent().parent()
      $(scrollParent).scrollTop(value)
    },
    focus(type) {
      let el = $("#" + type + "-select")
      el.focus()
    },
    fetchLookupByName(name) {
      return this.listLookupsByMasterName(name)
    },
    idToLookup(lookupList, id) {
      let lookupItem = lookupList.find((item) => item.LookupId === +id)
      if (lookupItem) {
        return lookupItem.LookupId
      } else {
        return null
      }
    },
    async defineLookups() {
      try {
        this.states = await this.fetchLookupByName("States")
        this.countries = await this.fetchLookupByName("CountryCodes")
        if (this.isEdit) {
          this.fillFormData()
        }
      } catch (error) {
        console.error(error)
      }
    },
    fillFormData() {
      if (!this.isEdit) return
      this.firstName = this.drPersonal.firstName || ""
      this.lastName = this.drPersonal.lastName || ""
      this.email = this.drPersonal.emailAddress || ""
      this.cellPhone = this.drPersonal.cellNumber || ""
      this.allowSMS = this.drPersonal.allowSMS || false
      this.isReader = this.drPersonal.isReader || false
      this.radio_qualification = this.drCredentials.qualification.toString() || ""
      this.address = this.drPersonal.address1 || ""
      this.city = this.drPersonal.city || ""
      this.state = this.idToLookup(this.states, this.drPersonal.state) || ""
      this.zipCode = this.drPersonal.zipCode || ""
      this.country = this.idToLookup(this.countries, this.drPersonal.country) || ""
    },
    handlePreview(file) {
      this.model.imageUrl = URL.createObjectURL(file.raw)
    },
    getError(fieldName) {
      return this.errors.first(fieldName)
    },
    validate() {
      this.storeValues()
      return this.$validator.validateAll().then((res) => {
        this.$emit("on-validated", res)
        return res
      })
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.createImage(files[0])
    },
    createImage(file) {
      var reader = new FileReader()
      var vm = this

      reader.onload = (e) => {
        vm.image = e.target.result
      }
      reader.readAsDataURL(file)
    },
    storeValues() {
      this.drPersonal.firstName = this.firstName
      this.drPersonal.lastName = this.lastName
      this.drPersonal.emailAddress = this.email
      this.drPersonal.cellNumber = this.cellPhone
      this.drPersonal.allowSMS = this.allowSMS
      this.drPersonal.isReader = this.isReader
      this.drCredentials.qualification = +this.radio_qualification
      this.drPersonal.address1 = this.address
      this.drPersonal.city = this.city
      this.drPersonal.state = this.state
      this.drPersonal.zipCode = this.zipCode
      this.drPersonal.country = this.country
    },
    showTooltip() {
      clearTimeout(this.hideTimeout);
      this.tooltipVisible = true;

      this.$nextTick(() => {
        const tooltip = this.$refs.tooltip;
        const wrapper = this.$refs.wrapper;
        if (!tooltip || !wrapper) return;
        const tooltipRect = tooltip.getBoundingClientRect();
        const overflowLeft = tooltipRect.left < 0;
        if (overflowLeft) {
          tooltip.style.left = '-100px';
          tooltip.style.right = 'auto';
          tooltip.style.transform = 'none';
        }
      });
    },
    closeSMSModal() {
      this.showModalSMS = false;
    },
    hideTooltipWithDelay() {
      this.hideTimeout = setTimeout(() => {
        this.tooltipVisible = false;
      }, 500);
    },
  }
}
</script>
<style scoped>
.lbl1 {
  font-size: 0.7rem;
  color: rgba(0, 0, 0, 0.6);
}

.info-icon {
  font-size: 16px;
  cursor: pointer;
  color: #666;
}

.tooltip-wrapper:hover .tooltip-content {
  visibility: visible;
  opacity: 1;
}

.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-content {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  color: black;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  z-index: 9999;
  white-space: normal;
  max-width: 280px;
  word-wrap: break-word;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  background-color: #e4e4e5;
}


.tooltip-content ul {
  padding-left: 1.2rem;
  margin: 0;
}

.tooltip-content li {
  margin-bottom: 0.5rem;
  list-style-type: disc;
  color: black;
  font-size: 0.75rem;
}

.sms-switch {
  margin: 8px 8px 8px 0;
}

.modal {
  padding: 12px;
  display: flex;
  flex-direction: column;
}

.md-dialog {
  border-radius: 12px;
  max-width: 500px;
  width: 80%;
}

.md-dialog-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  padding: 12px 8px 0;
}

.md-dialog-content {
  font-size: 0.95rem;
  color: #444;
  line-height: 1.6;
}

.md-dialog-content ul {
  margin-top: 0.5rem;
}

.md-dialog-content li {
  margin-bottom: 0.75rem;
}

.md-dialog-content a {
  color: #1976d2;
  text-decoration: underline;
  transition: color 0.3s;
}

.md-dialog-content a:hover {
  color: #0d47a1;
}

.md-dialog-actions {
  display: flex;
  justify-content: flex-end;
}

.md-dialog-actions .md-button {
  background-color: #1976d2;
  color: white;
  border-radius: 4px;
  font-weight: 500;
  text-transform: none;
  transition: background-color 0.3s;
}

.md-dialog-actions .md-button:hover {
  background-color: #0d47a1;
}
</style>